<template>
  <div class="articles">
    <section class="blog garden-set-pd-sm-lg" v-if="!loading">
      <div v-if="postArticles">
        <div class="container">
          <ul class="row">
            <div class="col-md-12 alert alert-info" v-if="searchResults">
              <h3 class="text-center">{{ searchResults }}</h3>
            </div>
            <li
              class="col-md-4 col-sm-6"
              v-for="(article, index) in postArticles"
              :key="index"
            >
              <div class="box">
                <div class="garden-img-full-width garden-overlay-scale">
                  <img
                    v-if="article.featuredImage"
                    :src="article.featuredImage"
                    alt
                  />
                  <img v-else :src="article.image" alt />
                  <div class="garden-overlay">
                    <div class="garden-button">
                      <router-link
                        :to="{
                          name: 'SinglePost',
                          params: {
                            type: type,
                            slug: `${article.slug}`
                          }
                        }"
                        >{{ $t('readMore') }}</router-link
                      >
                    </div>
                  </div>
                </div>
                <div class="meta">
                  <ul>
                    <li>
                      <p v-if="article.chargerDuProjet">
                        <span class="fa fa-user"></span>
                        {{ article.chargerDuProjet }}
                      </p>
                      <p v-else>
                        <span class="fa fa-user"></span>
                        Afrik Eveil
                      </p>
                    </li>
                    <li>
                      <p>
                        <span class="fa fa-calendar"></span>
                        {{ format_date(article.created_at) }}
                      </p>
                    </li>
                    <li>
                      <p>
                        <span class="fa fa-clock-o"></span>
                        <timeago
                          :datetime="article.created_at"
                          :locale="locale"
                        ></timeago>
                      </p>
                    </li>
                  </ul>
                </div>
                <a href="#" class="garden-hv-child-color-primary">
                  <h3 class="title text-center">
                    <router-link
                      :to="{
                        name: 'SinglePost',
                        params: {
                          type: type,
                          slug: `${article.slug}`
                        }
                      }"
                    >
                      {{ article.title.substring(0, 60) }}{{ ' ...' }}
                    </router-link>
                  </h3>
                </a>
                <p class="content">
                  {{ decodeHtml(article.content) | strippedContent }}{{ '...' }}
                </p>
                <router-link
                  :to="{
                    name: 'SinglePost',
                    params: {
                      type: type,
                      slug: `${article.slug}`
                    }
                  }"
                  class="btn btn-md readMore"
                >
                  {{ $t('readMore') }}{{ ' ' }}
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </router-link>
              </div>
            </li>
          </ul>
        </div>
        <div class="garden-pagination text-center">
          <ul v-if="postPagination.mumberOfPages > 1">
            <li class="arrow prev" v-if="postPagination.previous == null">
              <button disabled>
                <i class="fa fa-arrow-left"></i>
              </button>
            </li>
            <li class="arrow prev" v-else>
              <a
                @click="getArticles(postPagination.previous.previous_page_url)"
              >
                <i class="fa fa-arrow-left"></i>
              </a>
            </li>
            <template v-for="i in postPagination.mumberOfPages">
              <template v-if="i == postPagination.current_page">
                <li :key="i" class="active">
                  <a href="#">{{ i }}</a>
                </li>
              </template>
              <template v-else>
                <li :key="i">
                  <a href="#" @click="getArticlesByPage(i)">{{ i }}</a>
                </li>
              </template>
            </template>
            <li class="arrow next" v-if="postPagination.next == null">
              <button disabled>
                <i class="fa fa-arrow-right"></i>
              </button>
            </li>
            <li class="arrow next" v-else>
              <a @click="getArticles(postPagination.next.next_page_url)">
                <i class="fa fa-arrow-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <Loader v-else />
  </div>
</template>

<script>
import Axios from 'axios';
import moment from 'moment';
import APPURL from '../constant';
export default {
  watch: {
    $route() {
      this.getLang();
      this.format_date();
    }
  },
  mounted() {
    this.getLang();
  },
  data() {
    return {
      locale: '',
      loading: false,
      postArticles: {},
      postPagination: {},
      categoryId: '',
      error: false
    };
  },
  methods: {
    getCategoryName(id) {
      var url = APPURL.LINK + 'category/' + id;
      Axios.get(url).then(response => {
        var name = '';
        name = response.data.data.results[0].name;
        //console.log(response.data.data.results[0].name);
        return name;
      });
    },
    decodeHtml: function(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    getLang() {
      this.locale = this.$i18n.locale;
      this.postArticles = this.articles;
      this.postPagination = this.pagination;
      //console.log('type is ', this.type);
    },
    format_date(value) {
      if (value) {
        if (this.$i18n.locale == 'en') {
          return moment(String(value)).format('MM/DD/YYYY');
        } else {
          return moment(String(value)).format('DD/MM/YYYY');
        }
      }
    },
    getArticlesByPage(page) {
      let url = '';
      if (this.paginationType == 'search') {
        url =
          APPURL.LINK +
          'articles-by-category/' +
          this.$i18n.locale +
          '/' +
          this.$root.categoryId +
          '/' +
          page +
          '/18';
        //console.log(url);
      } else {
        url =
          APPURL.LINK +
          this.paginationType +
          '/' +
          this.$i18n.locale +
          '/' +
          page +
          '/18';
      }
      this.loading = true;
      Axios.get(url).then(response => {
        if (this.paginationType == 'covids') {
          this.postArticles = response.data.data.results.covids;
          this.postPagination = response.data.data.pagination;
          //console.log('this.postArticles', this.postArticles);
        } else {
          this.postArticles = response.data.data.results.posts;
          this.postPagination = response.data.data.pagination;
        }
        this.loading = false;
        //console.log(this.postPagination);
        //console.log(this.postPagination);
      });
    },
    getArticles(url) {
      this.loading = true;
      Axios.get(url).then(response => {
        if (this.paginationType == 'covids') {
          this.postArticles = response.data.data.results.covids;
          this.postPagination = response.data.data.pagination;
          //console.log('this.postArticles', this.postArticles);
        } else {
          this.postArticles = response.data.data.results.posts;
          this.postPagination = response.data.data.pagination;
        }
        this.loading = false;
        //console.log(this.postPagination);
      });
    }
  },
  filters: {
    strippedContent: function(string) {
      return string.replace(/<[^>]+>/g, ' ').substring(0, 200);
    }
  },
  name: 'Articles',
  props: {
    articles: {},
    pagination: {},
    searchResults: {},
    type: String,
    paginationType: String
  }
};
</script>

<style scoped lang="scss">
.alert h3 {
  font-size: 20px;
  padding: 5px;
  color: black;
}
button {
  width: auto;
  border: 1px dashed #228c4f;
  border-radius: 25px;
  letter-spacing: 1px;
  padding: 0 20px;
  font-weight: 700;
}
button i {
  font-weight: 700;
  color: #4e5453;
  font-size: 12px;
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  border-radius: 5px;
}
.blog {
  margin-top: -60px;
}
.box {
  margin-bottom: 20px !important;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-bottom: 5px solid #fff;
}
.box:hover {
  border-bottom: 5px solid #228c4f;
}
.title a {
  /* border: 2px solid red; */
  height: 60px;
  display: block;
  margin-bottom: 0px;
  font-size: 15px;
  color: #228c4f;
}
.readMore {
  width: 209px !important;
  background: #228c4f;
  line-height: 20px !important;
  padding: 8px !important;
  border: 2px solid transparent;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  margin-left: 50px !important;
  border-radius: 8px;
}
.readMore:hover {
  color: #fbec64;
  border: 2px solid #fbec64;
  background: #104627;
}
.garden-img-full-width img,
.garden-overlay {
  border-radius: 8px;
}
.garden-img-full-width img {
  width: 100%;
  height: 200px;
  position: relative;
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
.meta {
  border: 1px dashed #228c4f;
  border-radius: 33px;
  padding-left: 20px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.content {
  font-size: 13px !important;
  height: 150px;
  color: #000;
  font-weight: 400;
  text-align: justify;
}
.meta li {
  display: inline-block;
  padding-right: 5px;
  margin-bottom: 0px !important;
}
.meta li p {
  font-size: 12px;
  color: #4e5453;
  font-weight: 400;
}
.meta li p span {
  padding-right: 7px;
  color: #228c4f;
}
</style>
